module.exports = __webpack_public_path__ + "img/w3_facebook_white.4a33631c.png";